<template>
	<v-card>
		<app-schedule-tour-title @close="$emit('close')" />

		<v-card-text class="text-xs-center">
			<v-alert :value="true" type="error" class="text-xs-left errMsg mb-4">
				<h2>Error</h2>
			</v-alert>
			<p>{{ errMsg }}</p>
			<p>Please call or email us to schedule your tour.</p>
			<p>We apologize for any inconvenience.</p>
		</v-card-text>

		<v-card-actions class="px-5 pb-3 justify-center">
			<v-btn color="blue" dark href="tel:1-973-839-0737"><v-icon>call</v-icon></v-btn>
			<v-btn color="blue" dark href="mailto:allstarkidsnj@gmail.com"><v-icon>mail_outline</v-icon></v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
export default {
	components: {
		AppScheduleTourTitle: () => import('@/components/schedule-tour/Title.vue'),
	},

	props: {
		errMsg: {
			type: String,
			default: '',
		},
	},
}
</script>

<style>
.errMsg * {
	color: #fff;
}
.errMsg p {
	margin: .25rem;
}
</style>
